import { render, staticRenderFns } from "./PassesUserAction.vue?vue&type=template&id=7f485873&scoped=true"
import script from "./PassesUserAction.vue?vue&type=script&lang=js"
export * from "./PassesUserAction.vue?vue&type=script&lang=js"
import style0 from "./PassesUserAction.vue?vue&type=style&index=0&id=7f485873&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f485873",
  null
  
)

export default component.exports